var exports = {
  "wrapper": "xaee3c4fa--f1de0a--wrapper",
  "_white": "xaee3c4fa--f1de0a--_white",
  "_gray": "xaee3c4fa--f1de0a--_gray",
};

module.exports = exports;
